module.exports = __webpack_public_path__ + "thumbnail-7387d6e4df34aa924c737527eefccbbb.png";